import { render, staticRenderFns } from "./DeleteConfirm.vue?vue&type=template&id=0388dfcb&scoped=true&"
import script from "./DeleteConfirm.vue?vue&type=script&lang=js&"
export * from "./DeleteConfirm.vue?vue&type=script&lang=js&"
import style0 from "./DeleteConfirm.vue?vue&type=style&index=0&id=0388dfcb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0388dfcb",
  null
  
)

export default component.exports